import { defineStore } from 'pinia';

import { projectLangs, type TLocale } from '@/config/lang';

const LANG_KEY = 'locale';

export const useLangStore = defineStore('lang', {
  state: () => ({
    currentLang: (localStorage.getItem(LANG_KEY) as TLocale) || 'en-US',
    project: 'default'
  }),

  getters: {
    langOptions: (state) => projectLangs[state.project] || projectLangs.default,
    currentLabel(): string {
      return this.langOptions.find((l) => l.value === this.currentLang)?.label || '';
    }
  },

  actions: {
    // 设置语言
    setLang(locale: TLocale) {
      this.currentLang = locale;
      localStorage.setItem(LANG_KEY, locale);
    },
    // 设置项目
    setProject(project: string) {
      this.project = project;
    },
    // 初始化项目
    initProject() {
      const match = location.pathname.match(/\/main-([\w-]+)(?:\/|$)/);
      this.project = match?.[1] && projectLangs[match[1]] ? match[1] : 'default';
    }
  }
});
